import { Drawer, DrawerContent, DrawerHeader, DrawerTitle, DrawerDescription, DrawerFooter } from "@/components/ui/drawer";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";

// Queues a revision note against one matchup. Nothing is sent to the model here —
// notes pile up and go out together when the admin presses Apply.
const NoteSheet = ({
  open,
  onOpenChange,
  matchupLabel,
  note,
  onNoteChange,
  hasQueuedNote,
  saving,
  onSave,
  onRemove,
}: {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  matchupLabel: string;
  note: string;
  onNoteChange: (v: string) => void;
  hasQueuedNote: boolean;
  saving: boolean;
  onSave: () => void;
  onRemove: () => void;
}) => (
  <Drawer open={open} onOpenChange={onOpenChange}>
    <DrawerContent>
      <DrawerHeader>
        <DrawerTitle>{hasQueuedNote ? "Edit queued change" : "Queue a change"}</DrawerTitle>
        <DrawerDescription>
          {matchupLabel} — say what to change, or leave it blank to just try again. Nothing runs until you press Apply.
        </DrawerDescription>
      </DrawerHeader>
      <div className="space-y-1.5 px-4 pb-2">
        <Label>Note (optional)</Label>
        <Textarea
          placeholder="e.g. shorter, lead with the qualifying gap, end with a question"
          value={note}
          onChange={(e) => onNoteChange(e.target.value)}
          rows={3}
        />
      </div>
      <DrawerFooter>
        <Button disabled={saving} onClick={onSave}>
          {saving ? "Saving…" : hasQueuedNote ? "Update note" : note.trim() ? "Queue change" : "Queue retry"}
        </Button>
        {hasQueuedNote && (
          <Button variant="outline" className="text-destructive hover:text-destructive" disabled={saving} onClick={onRemove}>
            Remove from queue
          </Button>
        )}
      </DrawerFooter>
    </DrawerContent>
  </Drawer>
);

export default NoteSheet;
